import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useContext, useEffect } from 'react';
import ProductGrid from '../../components/ProductGrid/ProductGrid';
import { SiteContext } from '../../utils/common';
import Link from '../Link/Link';
import RawHtml from '../RawHtml/RawHtml';
import useStyles from './ProductGallery.styles';
import ProductGalleryCarousel from './ProductGalleryCarousel/ProductGalleryCarousel';
import { useRouter } from 'next/router';
export const PRODUCT_GALLERY_UK_AMP_KEY = 'component/404-product-gallery';
export const PRODUCT_GALLERY_IE_AMP_KEY = 'component/404-product-gallery-ie';
export const PRODUCT_GALLERY_FF_AMP_KEY = 'component/404-product-gallery-ff';
const ProductGallery = (props) => {
    var _a;
    const { title, body, products, galleryDisplayType, linksAfter, headingTag, showSkeleton, setShowSkeleton, titleAlignment = 'CENTER', messageAlignment = 'CENTER', } = props;
    const { addToBasket, cardDisplayType = 'CONCISE', pdpRecommendationAnalytics } = props;
    const { isFlyingFlowers } = useContext(SiteContext);
    const { classes } = useStyles();
    const router = useRouter();
    const isDeliveryPassCardType = cardDisplayType === 'DELIVERY_PASS';
    const isCarouselGalleryDisplay = galleryDisplayType === 'CAROUSEL';
    const isGridGalleryDisplay = galleryDisplayType === 'GRID';
    const isPdpPage = (_a = router === null || router === void 0 ? void 0 : router.asPath) === null || _a === void 0 ? void 0 : _a.includes('/product');
    const shouldContentLeftAligned = isPdpPage && isCarouselGalleryDisplay;
    const HeadingTag = headingTag ? headingTag.toLowerCase() : 'h3';
    const tagMap = {
        h1: 'h2',
        h2: 'h3',
        h3: 'h4',
        h4: 'div',
        div: 'div',
    };
    const cardHeadingTag = tagMap[HeadingTag] || 'h4';
    useEffect(() => {
        if (products && products.length > 0 && showSkeleton && setShowSkeleton) {
            setShowSkeleton(false);
        }
    }, [products, showSkeleton, setShowSkeleton]);
    return (_jsxs("div", { className: clsx(classes.productGallery, isDeliveryPassCardType ? classes.deliveryPass : '', shouldContentLeftAligned ? classes.carouselProductGallery : ''), children: [!showSkeleton && (_jsxs(_Fragment, { children: [title && (_jsx(HeadingTag, { className: clsx(classes.title, isCarouselGalleryDisplay ? classes.carouselTitle : '', titleAlignment === 'LEFT' && classes.contentLeft), children: title })), body && (_jsx(RawHtml, { className: clsx(isGridGalleryDisplay ? classes.headingSection : '', classes.message, isCarouselGalleryDisplay ? classes.carouselMessage : '', messageAlignment === 'LEFT' && classes.contentLeft), content: body }))] })), !!(products === null || products === void 0 ? void 0 : products.length) &&
                !showSkeleton &&
                (isCarouselGalleryDisplay && !isDeliveryPassCardType ? (_jsx(ProductGalleryCarousel, { products: products, cardDisplayType: cardDisplayType, pdpRecommendationAnalytics: pdpRecommendationAnalytics, isCarouselGalleryDisplay: isCarouselGalleryDisplay, nameTag: cardHeadingTag })) : (_jsx(ProductGrid, { breakpoints: {
                        small: 12,
                        medium: 4,
                        large: 3,
                    }, products: products, cardDisplayType: cardDisplayType, addToBasket: addToBasket, pdpRecommendationAnalytics: pdpRecommendationAnalytics, isFromProductCarousel: true, nameTag: cardHeadingTag }))), linksAfter && !showSkeleton && (_jsx("div", { className: classes.linkContainer, children: linksAfter.map((link) => (_jsx(Link, Object.assign({ button: true, variant: 'tertiary', thin: true }, link, { className: classes.link, icon: isFlyingFlowers ? 'refresh' : undefined }), `product_gallery_${link.label}`))) }))] }));
};
export default ProductGallery;
